import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase/config';

const AdminRoute = ({ user, children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        // Verify the current auth state matches the passed user
        if (auth.currentUser?.uid !== user.uid) {
          console.error("User mismatch in AdminRoute");
          setError("Authentication error");
          setLoading(false);
          return;
        }

        // Get a fresh ID token to ensure claims are up to date
        await auth.currentUser.getIdToken(true);
        
        // Get user document from Firestore
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const adminStatus = userData.role === 'admin';
          setIsAdmin(adminStatus);
        } else {
          setError("User document not found");
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setError("Failed to verify admin status");
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  if (loading) {
    return <div>Verifying permissions...</div>;
  }

  if (error) {
    return <Navigate to="/" />;
  }

  return isAdmin ? children : <Navigate to="/" />;
};

export default AdminRoute;
